import React from "react";
import { Box } from "@mui/material";

const PillBox = ({
  value,
  bgColor = "#ff9998",
  color = "#000",
//   fontSize = "0.875rem",
  paddingY = 0.5,
  paddingX = 1,
  width = "150px"
}) => {
  return (
    <Box
      sx={{
        width: width,
        backgroundColor: bgColor,
        color: color,
        borderRadius: "10px",  
        py: paddingY,
        px: paddingX,
        // fontSize: fontSize,
        // fontWeight: 500,
        textAlign: "center",
        boxSizing: "border-box",
        userSelect: "none",
        mx: "auto"
      }}
    >
      {value}
    </Box>
  );
};

export default PillBox;
